import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AutoCompleteService } from '@elotech/angular-common';
import { EntityService, HttpClient, PageParameters } from '@elotech/angular-common';
import { PericiaAfastamento } from '../components/pericia-afastamento/pericia-afastamento';



@Injectable()
export class PericiaAfastamentoService extends EntityService<PericiaAfastamento> implements AutoCompleteService {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/pericia-afastamento';
  }

  public findOneByMovimentacaoId(movimentacaoId: number): Observable<PericiaAfastamento> {
    return this.httpClient.get({
      resource: `${this.resource}/movimentacao/${movimentacaoId}`,
      disableSpinner: true
    });
  }
}
